import * as React from 'react';
import { ModalProps } from '../../modal';
import { ScrollableOverlay } from '../../scrollable-overlay/scrollable-overlay';
import overlayStyles, { ScrollableOverlayBodyStyle } from '../../../styles/scrollable-overlay';
import { classes, style } from 'typestyle';
import { px } from 'csx';
import { ComponentProps, deps, inject, observer } from '../../../lib/component';
import { rebrand } from '../../../theme/color';
import { Banner } from '../atoms/Banner';
import { SemanticInformationType } from '../utilities/types';
import { Link } from '../atoms/Link';

const styles = {
  wrapper: style({
    display: 'block',
    maxWidth: px(440),
  }),
  heading: style({
    fontSize: px(32),
  }),
  body: style(ScrollableOverlayBodyStyle, {
    padding: '1.5rem 0 0',
    borderTop: `1px solid ${rebrand.light1.toString()}`,
    $nest: {
      '& > p': {
        margin: '1.5rem 0 0',
      },
    },
  }),
  banner: style({
    fontSize: px(20),
  }),
  contactLink: style({
    textDecoration: 'underline',
  }),
};

export type TrialNotEligibleModalProps = ModalProps & { className?: string };

export const TrialNotEligibleModal: React.FC<TrialNotEligibleModalProps & ComponentProps> = inject(deps)(
  observer(({ show, onRequestClose }) => {
    return (
      <ScrollableOverlay
        className={styles.wrapper}
        show={show}
        onRequestClose={onRequestClose}
        data-test-trial-not-eligible-modal
      >
        <div className={overlayStyles.header}>
          <h3 className={classes(overlayStyles.title, styles.heading)}>Free trial not available</h3>
        </div>

        <div className={styles.body}>
          <Banner type={SemanticInformationType.WARNING} className={styles.banner}>
            Sorry, you aren't eligible for the free trial offer
          </Banner>

          <p>
            The free trial offer isn't available for everyone just yet. We're happy to help you find the right plan -
            <Link
              href="https://share-eu1.hsforms.com/1K6RC3DzGRgW4HjWuQwA9owfvz1n"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.contactLink}
            >
              please get in touch
            </Link>{' '}
            or check out your options on this page.
          </p>
        </div>
      </ScrollableOverlay>
    );
  })
);
